import { request } from '@/utils/http'

/**
 * 任务记录状态枚举
 */
export enum TaskRecordStatusEnum {
  PROCESSING = 1, // 处理中
  COMPLETED = 2,  // 已完成
  FAILED = 3,     // 失败
  PENDING = 4,    // 等待中
  STOPPED = 5,    // 已停止
  PUBLISHED = 6   // 已上架（整箱运价导入状态）
}

/**
 * 任务记录类型枚举
 */
export enum TaskRecordTypeEnum {
  FULL_CONTAINER_FREIGHT_IMPORT = 1, // 整箱运价导入
  PRE_PORT_FREIGHT_IMPORT = 2,      // 港前运价导入
  PRICE_QUERY_EXPORT = 3,           // 运价查询导出
  LAST_MILE_FREIGHT = 4,            // 尾程运价
  AI_CUSTOMER_ACQUISITION_IMPORT = 5, // AI获客导入
  ORDER_EXPORT = 6,                  // 订单导出
  PORT_PLATFORM_COPY = 7,           // 平台港口复制
  WAREHOUSE_PLATFORM_COPY = 8,       // 平台仓库复制
  ROUTE_PLATFORM_COPY = 10,           // 平台航线复制
  LAST_MILE_FREIGHT_IMPORT = 14,      // 尾程运价导入
  LCL_FREIGHT_IMPORT = 15,            // 拼箱运价导入
  AIR_FREIGHT_IMPORT = 16,            // 空运运价导入
  SURCHARGE_LCL_IMPORT = 17,         // 拼箱附加费导入
  SURCHARGE_AIR_IMPORT = 18,         // 空运附加费导入
  EXPRESS_FREIGHT_IMPORT = 19,        // 快递运价导入
  SURCHARGE_FCL_IMPORT = 30,         // 整箱附加费导入
  SURCHARGE_PRE_PORT_IMPORT = 31,    // 港前附加费导入
  SURCHARGE_LAST_MILE_IMPORT = 32,   // 尾程附加费导入
  RAIL_FREIGHT_IMPORT = 33,          // 铁路运价导入
  RAIL_FREIGHT_EXPORT = 34,          // 铁路运价导出
  RAIL_SURCHARGE_EXPORT = 35,        // 铁路附加费导出
  RAIL_SURCHARGE_IMPORT = 36,        // 铁路附加费导入
  WAREHOUSE_FCL_FREIGHT_IMPORT = 50, // 运价库整箱运价导入
  WAREHOUSE_LCL_FREIGHT_IMPORT = 51, // 运价库拼箱运价导入
  WAREHOUSE_AIR_FREIGHT_IMPORT = 52, // 运价库空运运价导入
  WAREHOUSE_PRE_PORT_FREIGHT_IMPORT = 53, // 运价库港前运价导入
  WAREHOUSE_LAST_MILE_FREIGHT_IMPORT = 54, // 运价库尾程运价导入
  FCL_PRICE_RATIO = 55, // 整箱运价配比（与后端 TaskRecordTypeEnum.FCL_PRICE_RATIO 对齐）
  TEXT_RATE_AI_IMPORT = 56 // 文字运价AI导入
}

/**
 * 任务操作类型枚举
 */
export enum TaskOperationTypeEnum {
  IMPORT = 1, // 导入
  EXPORT = 2  // 导出
}

/**
 * 任务记录查询请求参数
 */
export interface SysTaskRecordQueryRequest {
  pageNum?: number
  pageSize?: number
  taskType?: TaskRecordTypeEnum
  operationType?: number
  fileName?: string
  fileId?: string
  status?: TaskRecordStatusEnum
  batchNo?: string
  createdBy?: number
  startTime?: string
  endTime?: string
}

/**
 * 任务记录VO
 */
export interface SysTaskRecordVO {
  id: string
  fileId: string
  fileName: string
  creator: string
  createdBy?: number
  createdByAliasCn: string
  status: TaskRecordStatusEnum
  taskType: TaskRecordTypeEnum
  operationType: TaskOperationTypeEnum
  startTime?: string
  endTime?: string
  remark?: string
  batchNo?: string
  progress?: number
  taskConfigJson?: string
  taskResultJson?: string
  dateCreated: string
  dateModified: string
}

/**
 * 分页结果
 */
export interface PageResult<T> {
  records: T[]
  total: number
  size: number
  current: number
  pages: number
}

/**
 * 主键请求参数
 */
export interface PrimaryKeyRequest {
  ids: string[]
}
/**
 * 分页查询任务记录列表
 * @param params 查询参数
 */
export function pageTaskRecord(params: SysTaskRecordQueryRequest): Promise<PageResult<SysTaskRecordVO>> {
  return request.post<PageResult<SysTaskRecordVO>>('sys/sysTaskRecord/page', params)
}

/**
 * 删除任务记录（支持单个和批量删除）
 * @param params 主键请求参数
 */
export function deleteTaskRecord(params: PrimaryKeyRequest): Promise<boolean> {
  return  request.post<boolean>('sys/sysTaskRecord/delete', params)
}

/**
 * 更新任务状态
 * @param params 更新任务状态请求参数
 */
export function updateTaskStatus(params: {
  id: string
  status: TaskRecordStatusEnum
}): Promise<boolean> {
  return request.post<boolean>('sys/sysTaskRecord/update', params)
}

/**
 * 根据ID查询单条任务记录
 * @param id 任务记录ID
 */
export function getTaskRecordById(id: string): Promise<SysTaskRecordVO> {
  return request.post<SysTaskRecordVO>('sys/sysTaskRecord/get', { id })
}
